export default __webpack_public_path__ + "static/media/points.30f1ad06.svg";